import { Core } from "@faire/design-tokens";
import styled, { css } from "styled-components";

interface IProps {
  /** Color for filled region of the bar, default color is set as faireBlack */
  $color?: string;
  /** Color for unfilled region of the bar, default background color is set as fog */
  $backgroundColor?: string;
  /** How much filled region the component have. It should range from 0 ~ 100 */
  $progress: number;
  /** Set to true, then the progress indicator bar will change with smooth animation */
  $smooth?: boolean;
  /** Set to define the height of the progress bar, default height is set as 6px */
  $height?: string;
}

/**
 * @trackcomponent
 * @supersededBy "@faire/web/slate/ProgressBar/ProgressBar#ProgressBar"
 */
export const BareProgressBar = styled.div<IProps>`
  position: relative;
  border-radius: 3px;
  background-color: ${({ $backgroundColor: backgroundColor }) =>
    backgroundColor ?? Core.surface.subdued};
  height: ${({ $height: height }) => height ?? "6px"};
  flex: 1;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 3px;
    background-color: ${({ $color: color }) => color ?? Core.surface.default};
    height: 100%;
    ${({ $smooth: smooth, $progress: progress }) =>
      smooth
        ? css`
            width: ${progress}%;
            transition: width 0.4s cubic-bezier(0.7, -0.4, 0.4, 1.4); // Ease In and Out Back
          `
        : css`
            width: ${progress}%;
          `};
  }
`;
